'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBoxOutline = function IoIosBoxOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.5 18.8h-5c-0.7 0-1.2 0.5-1.2 1.2s0.5 1.3 1.2 1.3h5c0.7 0 1.3-0.6 1.3-1.3s-0.6-1.2-1.3-1.2z m0-1.3c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h5z m10-8.7v6.2h-1.2v16.3h-22.5v-16.3h-1.3v-6.2h25z m-2.5 21.2v-15h-20v15h20z m1.3-16.2v-3.8h-22.5v3.8h22.5z' })
        )
    );
};

exports.default = IoIosBoxOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-box-outline.js
// module id = 2091
// module chunks = 0